<template>
  <div style="position: relative;">
    <el-row>
      <el-form ref="flowSpecialistAuditList" :model="flowSpecialistAuditList" label-width="120px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
        <filter-box :item-width="400">

          <!--        <el-row>-->
          <el-form-item label="工单状态" prop="formFilter.flowStatus">
            <el-select class="filter-item" v-model="flowSpecialistAuditList.formFilter.flowStatus" :clearable="true"
                       placeholder="工单状态">
              <el-option v-for="item in SysFlowWorkOrderStatus.getList()" :key="item.id"
                         :label="item.name" :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="创建日期" prop="formFilter.createTime">
            <date-range class="filter-item" v-model="flowSpecialistAuditList.formFilter.createTime" :clearable="true" :allowTypes="['day']" align="left"
                        range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                        format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" />
          </el-form-item>
          <el-form-item label="工单编号" prop="formFilter.workOrderCode">
            <el-input class="filter-item" v-model="flowSpecialistAuditList.formFilter.workOrderCode"
                      :clearable="true" placeholder="工单编号"
            />
          </el-form-item>
          <!--        </el-row>-->
          <!--        <el-row v-if="toggleSearchStatus">-->
          <template v-if="toggleSearchStatus">
            <el-form-item label="流程状态" prop="formFilter.latestApprovalStatus">
              <el-select class="filter-item" v-model="flowSpecialistAuditList.formFilter.latestApprovalStatus"
                         :clearable="true" filterable
                         placeholder="" :loading="flowSpecialistAuditList.latestApprovalStatus.impl.loading"
                         @visible-change="flowSpecialistAuditList.latestApprovalStatus.impl.onVisibleChange"
                         >
                <el-option v-for="item in flowSpecialistAuditList.latestApprovalStatus.impl.dropdownList" :key="item.id"
                           :value="item.id" :label="item.name"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="申请人名称" prop="formFilter.queryForm.specialistName">
              <el-input class="filter-item" v-model="flowSpecialistAuditList.formFilter.queryForm.specialistName"
                        :clearable="true" placeholder="申请人名称"
              />
            </el-form-item>
            <el-form-item label="手机号码" prop="formFilter.queryForm.mobilePhone">
              <el-input class="filter-item" v-model="flowSpecialistAuditList.formFilter.queryForm.mobilePhone"
                        :clearable="true" placeholder="手机号码"
              />
            </el-form-item>
            <el-form-item label="工作单位" prop="formFilter.queryForm.companyName">
              <el-input class="filter-item" v-model="flowSpecialistAuditList.formFilter.queryForm.companyName"
                        :clearable="true" placeholder="工作单位"
              />
            </el-form-item>
<!--            <el-form-item label="类型" prop="formFilter.queryForm.specialistType">-->
<!--              <el-select class="filter-item" v-model="flowSpecialistAuditList.formFilter.queryForm.specialistType"-->
<!--                         :clearable="true" filterable-->
<!--                         placeholder="" :loading="flowSpecialistAuditList.specialistType.impl.loading"-->
<!--                         @visible-change="flowSpecialistAuditList.specialistType.impl.onVisibleChange"-->
<!--              >-->
<!--                <el-option v-for="item in flowSpecialistAuditList.specialistType.impl.dropdownList" :key="item.id"-->
<!--                           :value="item.id" :label="item.name"-->
<!--                />-->
<!--              </el-select>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="批次" prop="formFilter.queryForm.batch">-->
<!--              <el-select class="filter-item" v-model="flowSpecialistAuditList.formFilter.queryForm.batch" :clearable="true"-->
<!--                         placeholder="批次">-->
<!--                <el-option v-for="item in batchSelect" :key="item.id"-->
<!--                           :label="item.name" :value="item.id"-->
<!--                />-->
<!--              </el-select>-->
<!--            </el-form-item>-->

          </template>
          <!--        <div>-->
          <el-button @click="toggleSearchStatus = !toggleSearchStatus" slot="operator" type="primary" :size="defaultFormItemSize"
                     :icon="toggleSearchStatus ? 'up' : 'down'">
            {{ toggleSearchStatus ? '收起' : '展开' }}
          </el-button>
          <!--    </el-row>-->

          <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onReset">重置</el-button>
          <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshFlowSpecialistAuditList(true)">查询</el-button>
          <el-button slot="operator" type="primary" :size="defaultFormItemSize"
                     @click="onStartTaskClick()">
            新建
          </el-button>
          <el-button slot="operator" type="primary" :size="defaultFormItemSize" v-if="checkPermCodeExist('specialist:specialist:export')"
                     :disabled="!checkPermCodeExist('specialist:specialist:export')"
                     @click="onExportSet()">
            导出配置
          </el-button>
          <el-button slot="operator" type="primary" :size="defaultFormItemSize" v-if="checkPermCodeExist('specialist:specialist:export')"
                     :disabled="!checkPermCodeExist('specialist:specialist:export')"
                     @click="onExportClick()">
            导出
          </el-button>
          <!--        </div>-->
        </filter-box>
      </el-form>

    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table ref="specialist" :data="specialistWidget.dataList" :size="defaultFormItemSize"
                  @sort-change="specialistWidget.onSortChange"
                  header-cell-class-name="table-header-gray">
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px"
                           :index="specialistWidget.getTableIndex"
          />
          <el-table-column label="工单编号" prop="workOrderCode" />
          <el-table-column label="申请人名称" prop="masterData.specialistName">
<!--            <template slot-scope="scope">-->
<!--              <span>{{(scope.row.masterData.specialistType=='2')?scope.row.masterData.teamName:scope.row.masterData.specialistName}}</span>-->
<!--            </template>-->
          </el-table-column>
          <el-table-column label="类型" prop="masterData.specialistTypeDictMap.name">
          </el-table-column>
          <el-table-column label="照片" min-width="100px">
            <template slot-scope="scope">
              <el-image v-for="item in parseUploadData(scope.row.masterData.specialistAvatar, {id: scope.row.masterData.id, fieldName: 'specialistAvatar', asImage: true})"
                        :preview-src-list="getPictureList(scope.row.masterData.specialistAvatar, {id: scope.row.masterData.id, fieldName: 'specialistAvatar', asImage: true})"
                        class="table-cell-image" :key="item.url" :src="item.url" :fit="fit" >
                <div slot="error" class="table-cell-image">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </template>
          </el-table-column>
          <el-table-column label="联系电话" prop="masterData.mobilePhone">
          </el-table-column>
          <el-table-column label="申请时间" prop="masterData.createTime">
            <template slot-scope="scope">
              <span>{{formatDateByStatsType(scope.row.masterData.createTime, 'day')}}</span>
            </template>
          </el-table-column>
          <el-table-column label="当前任务" prop="runtimeTaskInfo.taskName" />
          <el-table-column label="流程创建时间" prop="createTime" />
          <el-table-column label="流程状态" prop="latestApprovalStatusDictMap.name" width="100px" />
          <el-table-column label="工单状态" prop="flowStatus"  width="100px">
            <template slot-scope="scope">
              <span>{{SysFlowWorkOrderStatus.getValue(scope.row.flowStatus)}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150px" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" :size="defaultFormItemSize"
                         v-if="(scope.row.initTaskInfo || {}).taskKey !== (scope.row.runtimeTaskInfo || {}).taskKey"
                         @click.stop="onViewTaskClick(scope.row)">
                详情
              </el-button>
              <el-button type="text" :size="defaultFormItemSize"
                         v-if="(scope.row.initTaskInfo || {}).taskKey === (scope.row.runtimeTaskInfo || {}).taskKey
                         && scope.row.flowStatus !==6"
                         @click.stop="onViewTaskClick(scope.row)">
                详情
              </el-button>
              <el-button type="text" :size="defaultFormItemSize"
                         v-if=" scope.row.flowStatus ===6"
                         @click.stop="onSpecialistViewClick(scope.row)">
                详情
              </el-button>
              <el-button type="text" :size="defaultFormItemSize"
                         v-if="scope.row.createUserId === userInfo.userId && scope.row.flowStatus ===6"
                         @click.stop="onHandlerTaskClick(scope.row)">
                办理
              </el-button>
              <el-button type="text" :size="defaultFormItemSize"
                         v-if="scope.row.createUserId === userInfo.userId
                         &&scope.row.latestApprovalStatus ===3 && scope.row.runtimeTaskInfo.taskName==='认证申请'"
                         @click.stop="onHandlerTaskClick(scope.row)">
                办理
              </el-button>
              <el-button type="text" :size="defaultFormItemSize"
                         v-if="(scope.row.initTaskInfo || {}).taskKey === (scope.row.runtimeTaskInfo || {}).taskKey ||
                          ((scope.row.runtimeTaskInfo || {}).assigneeList
                          && (scope.row.runtimeTaskInfo || {}).assigneeList.includes(userInfo.loginName))"
                         @click.stop="onHandlerTaskClick(scope.row)">
                办理
              </el-button>

              <el-button type="text" :size="defaultFormItemSize" class="table-btn" v-if="scope.row.flowStatus !==6"
                         @click.stop="onRemindClick(scope.row)">
                催办
              </el-button>
              <el-button type="text" :size="defaultFormItemSize" class="table-btn error"
                         @click.stop="onCancelTaskClick(scope.row)">
                取消
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="specialistWidget.totalCount"
            :current-page="specialistWidget.currentPage"
            :page-size="specialistWidget.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="specialistWidget.onCurrentPageChange"
            @size-change="specialistWidget.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
    <el-dialog v-if="dialogVisible"
      title="导出配置"
      :visible.sync="dialogVisible"
      width="60%">
      <el-checkbox
        v-model="checkAll"
        @change="handleCheckAllChange"
        :indeterminate="isIndeterminate"
      >全选</el-checkbox>
        <el-checkbox-group v-model="checkedList" @change="handleCheckedCitiesChange">
          <el-checkbox v-for="(item,index) in dataList" :label="item.id" :key="index">{{item.name}}</el-checkbox>
        </el-checkbox-group>
      <div slot="footer" class="dialog-footer" style="margin-bottom: 20px;">
        <el-button @click="dialogVisible = false">关 闭</el-button>
        <el-button type="primary" @click="saveExportCheck">保 存</el-button>
      </div>

    </el-dialog>
  </div>
</template>

<script>
import '@/staticDict/flowStaticDict.js';
/* eslint-disable-next-line */
  import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
  import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
/* eslint-disable-next-line */
  import { SpecialistInfoController, DictionaryController,ExportSetController ,ExportCheckController} from '@/api';
import { FlowOperationController } from '@/api/flowController.js';
/* eslint-disable-next-line */
import ExportSet from '@/components/ExportSet'
const processDefinitionKey = 'flowSpecialistInfo';
const processDefinitionName = '特派员认证审核';

export default {
  components: {
  },
  name: 'flowSpecialListInfo',
  props: {
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      fit: 'scale-down',
      dialogVisible: false,
      toggleSearchStatus: false,
      checkAll: false,
      checkedList: [],
      checkedAllList: [],
      isIndeterminate: true,
      dataList: [],
      checkId: undefined,
      processDefinitionKey: processDefinitionKey,
      flowSpecialistAuditList: {
        formFilter: {
          flowStatus: undefined,
          workOrderCode: undefined,
          createTime: [],
          latestApprovalStatus: undefined,
          queryForm: {specialistName: undefined}
        },
        formFilterCopy: {
          flowStatus: undefined,
          workOrderCode: undefined,
          latestApprovalStatus: undefined,
          createTime: [],
          queryForm: {specialistName: undefined}
        },
        latestApprovalStatus: {
          impl: new DropdownWidget(this.loadLatestApprovalStatusDropdownList)
        },
        specialistType: {
          impl: new DropdownWidget(this.loadSpecialistTypeDropdownList)
        },
        isInit: false
      },
      specialistWidget: new TableWidget(this.loadSpecialistData, this.loadSpecialistVerify, true),
      userInfo: {},
      batchSelect: [{id: '十二', name: '十二'}, {id: '十三', name: '十三'}]
    }
  },
  methods: {
    onReset () {
      this.$refs.flowSpecialistAuditList.resetFields();
      this.refreshFlowSpecialistAuditList(true);
    },
    loadSpecialistData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        flowWorkOrderDtoFilter: {
          flowStatus: this.flowSpecialistAuditList.formFilterCopy.flowStatus,
          workOrderCode: this.flowSpecialistAuditList.formFilterCopy.workOrderCode,
          createTimeStart: Array.isArray(this.flowSpecialistAuditList.formFilterCopy.createTime) ? this.flowSpecialistAuditList.formFilterCopy.createTime[0] : undefined,
          createTimeEnd: Array.isArray(this.flowSpecialistAuditList.formFilterCopy.createTime)
            ? this.flowSpecialistAuditList.formFilterCopy.createTime[1] : undefined,
          queryForm: this.flowSpecialistAuditList.formFilterCopy.queryForm,
          latestApprovalStatus: this.flowSpecialistAuditList.formFilterCopy.latestApprovalStatus

        },
        orderParam: [
          {
            fieldName: 'createTime',
            asc: false
          }
        ]
      }
      params.flowWorkOrderDtoFilter.queryForm.batch = '十三'
      return new Promise((resolve, reject) => {
        SpecialistInfoController.listWorkOrderFlowSpecialistInfo(this, params).then(res => {
          let dataList = res.data.dataList.map(item => {
            item.initTaskInfo = JSON.parse(item.initTaskInfo);
            item.runtimeTaskInfo = Array.isArray(item.runtimeTaskInfoList) ? item.runtimeTaskInfoList[0] : undefined;
            item.masterData = item.masterData || {};
            return item;
          });
          resolve({
            dataList: dataList,
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        })
      });
    },
    loadSpecialistVerify () {
      this.flowSpecialistAuditList.formFilterCopy.flowStatus = this.flowSpecialistAuditList.formFilter.flowStatus;
      this.flowSpecialistAuditList.formFilterCopy.workOrderCode = this.flowSpecialistAuditList.formFilter.workOrderCode;
      this.flowSpecialistAuditList.formFilterCopy.createTime = this.flowSpecialistAuditList.formFilter.createTime;
      this.flowSpecialistAuditList.formFilterCopy.queryForm = this.flowSpecialistAuditList.formFilter.queryForm;
      this.flowSpecialistAuditList.formFilterCopy.latestApprovalStatus = this.flowSpecialistAuditList.formFilter.latestApprovalStatus;
      return true;
    },
    // 启动流程
    onStartTaskClick () {
      let that = this
      SpecialistInfoController.checkApply(this, {}).then(result => {
        if (result.data != null) {
          this.$message.info(result.data);
        } else {
          let params = {
            processDefinitionKey: processDefinitionKey
          }

          FlowOperationController.viewInitialTaskInfo(that, params).then(res => {
            if (res.data && res.data.taskType === that.SysFlowTaskType.USER_TASK && res.data.assignedMe) {
              that.$router.push({
                name: res.data.routerName || 'handlerFlowTask',
                query: {
                  processDefinitionKey: processDefinitionKey,
                  formId: res.data.formId,
                  routerName: res.data.routerName,
                  readOnly: res.data.readOnly,
                  taskName: '启动流程',
                  isDraft: true,
                  flowEntryName: processDefinitionName,
                  variableList: res.data.variableList,
                  operationList: (res.data.operationList || []).filter(item => {
                    return item.type !== that.SysFlowTaskOperationType.CO_SIGN && item.type !== that.SysFlowTaskOperationType.REVOKE;
                  })
                }
              });
            } else {
              FlowOperationController.startOnly(that, {
                processDefinitionKey: processDefinitionKey
              }).then(res => {
                that.$message.success('启动成功！');
              }).catch(e => {});
            }
          }).catch(e => {});
        }
      })
    },
    // 办理流程
    onHandlerTaskClick (row) {
      let taskId = (Array.isArray(row.runtimeTaskInfoList) && row.runtimeTaskInfoList.length > 0) ? row.runtimeTaskInfoList[0].taskId : undefined;
      let params = {
        processInstanceId: row.processInstanceId,
        processDefinitionId: row.processDefinitionId,
        taskId: taskId
      }

      FlowOperationController.viewRuntimeTaskInfo(this, params).then(res => {
        if (res.data) {
          this.$router.push({
            name: res.data.routerName || 'handlerFlowTask',
            query: {
              isRuntime: true,
              isDraft: row.flowStatus === this.SysFlowWorkOrderStatus.DRAFT,
              taskId: taskId,
              processDefinitionKey: processDefinitionKey,
              processInstanceId: row.processInstanceId,
              processDefinitionId: row.processDefinitionId,
              formId: res.data.formId,
              routerName: res.data.routerName,
              readOnly: res.data.readOnly,
              taskName: (row.runtimeInitialTask || {}).taskName,
              flowEntryName: row.processDefinitionName,
              processInstanceInitiator: row.processInstanceInitiator,
              operationList: (res.data.operationList || []).filter(item => {
                return item.type !== this.SysFlowTaskOperationType.CO_SIGN && item.type !== this.SysFlowTaskOperationType.REVOKE;
              }),
              variableList: res.data.variableList
            }
          });
        }
      }).catch(e => {});
    },
    // 查看流程
    onViewTaskClick (row) {
      let params = {
        processInstanceId: row.processInstanceId
      }
      let taskId = (Array.isArray(row.runtimeTaskInfoList) && row.runtimeTaskInfoList.length > 0) ? row.runtimeTaskInfoList[0].taskId : undefined;
      FlowOperationController.viewInitialHistoricTaskInfo(this, params).then(res => {
        if (res.data) {
          this.$router.push({
            name: res.data.routerName || 'handlerFlowTask',
            query: {
              isRuntime: false,
              taskId: taskId,
              processDefinitionKey: row.processDefinitionKey,
              processInstanceId: row.processInstanceId,
              processDefinitionId: row.processDefinitionId,
              routerName: res.data.routerName,
              readOnly: true,
              flowEntryName: row.processDefinitionName,
              processInstanceInitiator: row.processInstanceInitiator
            }
          });
        }
      }).catch(e => {});
    },
    /**
     * 导出设置
     */
    onExportSet () {
      let params = {
        exportCheckDtoFilter: {
          businessKey: processDefinitionKey
        }
      }
      // console.log(this.checkedList)
      // this.checkedList = []
      ExportCheckController.list(this, params).then(res => {
        if (res.data.dataList.length > 0) {
          if (res.data.dataList[0].setId) {
            this.checkedList = res.data.dataList[0].setId.split(',').map(Number)
            this.checkId = res.data.dataList[0].id
            // console.log(this.checkedList)
          }
        }
      })
      this.dialogVisible = true
    },
    /**
     * 导出
     */
    onExportClick () {
      let params = {
        flowWorkOrderDtoFilter: {
          flowStatus: this.flowSpecialistAuditList.formFilterCopy.flowStatus,
          workOrderCode: this.flowSpecialistAuditList.formFilterCopy.workOrderCode,
          createTimeStart: Array.isArray(this.flowSpecialistAuditList.formFilterCopy.createTime) ? this.flowSpecialistAuditList.formFilterCopy.createTime[0] : undefined,
          createTimeEnd: Array.isArray(this.flowSpecialistAuditList.formFilterCopy.createTime)
            ? this.flowSpecialistAuditList.formFilterCopy.createTime[1] : undefined,
          queryForm: this.flowSpecialistAuditList.formFilterCopy.queryForm
        },
        orderParam: [
          {
            fieldName: 'createTime',
            asc: false
          }
        ]
      };

      SpecialistInfoController.export(this, params, '科特派审核表.xlsx').then(res => {
        this.$message.success('导出成功');
      }).catch(e => {
        this.$message.error(e.errorMessage);
      });
    },
    // 催办
    onRemindClick (row) {
      FlowOperationController.remindRuntimeTask(this, {
        workOrderId: row.workOrderId
      }).then(res => {
        this.$message.success('催办成功');
      }).catch(e => {});
    },
    // 撤销流程
    onCancelTaskClick (row) {
      this.$confirm('是否取消此工单？').then(res => {
        let params = {
          workOrderId: row.workOrderId,
          cancelReason: '主动取消'
        }

        FlowOperationController.cancelWorkOrder(this, params).then(res => {
          this.$message.success('取消成功！');
          this.refreshFlowSpecialistAuditList();
        }).catch(e => {});
      }).catch(e => {});
    },
    // 刷新工单
    refreshFlowSpecialistAuditList (reloadData = false) {
      if (reloadData) {
        this.specialistWidget.refreshTable(true, 1);
      } else {
        this.specialistWidget.refreshTable();
      }
      if (!this.flowSpecialistAuditList.isInit) {
        // 初始化下拉数据
      }
      this.flowSpecialistAuditList.isInit = true;
    },
    handleCheckedCitiesChange (value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.dataList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.dataList.length;
    },
    handleCheckAllChange (val) {
      this.checkedList = val ? this.checkedAllList : [];
      this.isIndeterminate = false;
    },
    saveExportCheck () {
      // alert(this.checkedList)
      if (this.checkedList.length === 0) {
        this.$message.error('请选择字段');
      } else {
        let params = {
          exportCheckDto: {
            setId: this.checkedList.join(','),
            id: this.checkId,
            businessKey: processDefinitionKey
          }
        }

        ExportCheckController.add(this, params).then(res => {
          this.$message.success('保存成功');
        })
        this.dialogVisible = false
      }
    },
    onResume () {
      this.refreshFlowSpecialistAuditList();
    },
    formInit () {
      this.refreshFlowSpecialistAuditList();
      let filter = {
        // exportCheckDtoFilter: {
        businessKey: processDefinitionKey
        // }
      }
      ExportSetController.listDict(this, filter).then(res => {
        this.dataList = res.data
        res.data.forEach(item => {
          this.checkedAllList.push(item.id)
        })
      })
    },
    /**
     * 详情
     */
    onSpecialistViewClick (row) {
      let params = {
        processInstanceId: row.processInstanceId,
        viewFlag: 1,
        id: row.masterData.id
      };

      params.closeVisible = 1;
      this.$router.push({name: 'specialistInfoView', query: params});
    },
    loadLatestApprovalStatusDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictSysLatestApprovalStatusDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 类型下拉数据获取函数
     */
    loadSpecialistTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictSpecialistTypeDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    onFlowStatusValueChange (value) {

    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
    this.userInfo = this.$store.state.userInfo
  },
  watch: {
    '$route' () {
      this.formInit();
    }
  }
}
</script>

<style>
</style>
